module.exports = __webpack_public_path__ + "img/11087931_L.40415ccb.png";